export const recipesTr = {
  title: 'Reçeteler ve ürün ağaçları',
  subtitle: 'Sürümlü, denetlenebilir formüller ve çok seviyeli BOM yapıları.',
  empty: 'Seçilen filtrelere uyan reçete sürümü yok.',
  pagination: 'Sayfa {{page}} / {{pages}} · {{total}} sürüm',
  help: {
    open: 'Reçete ve BOM yardımını aç',
    list: 'Yaşam döngüsü, çıktı ürünü, bileşen veya geçerliliğe göre filtreleyin.',
    header:
      'Numara ve çıktı ürünü sabit reçete kimliğini oluşturur. İçerik kontrollü sürümlerle değiştirilir.',
    translations: 'Adlar ve açıklamalar desteklenen her dil için ayrı saklanır.',
    components:
      'Kalemler ürünlere veya onaylı alt reçetelere bağlanır. Miktar ve maliyetler kesin ondalıklarla hesaplanır.',
    dmsSnapshot: 'Tam olarak bu sürüm anlık görüntüsüne ait korumalı DMS asıllarını seçin.',
    history: 'Onaylı sürümler değişmez kalır ve yeni bir taslağa kopyalanabilir.',
    impact: 'Doğrudan üst reçeteleri ve tüm BOM hiyerarşisinde etkilenen ürünleri gösterir.',
    productUsage: 'Doğrudan kullanan tüm reçete ve ürünleri görmek için bir bileşen seçin.',
  },
  actions: {
    new: 'Yeni reçete / BOM',
    alternatives: 'Alternatifler',
    submit: 'İncelemeye gönder',
    review: 'İncelemeyi tamamla',
    approve: 'Onayla',
    copy: 'Sürümü kopyala',
    block: 'Bloke et',
    archive: 'Arşivle',
    addComponent: 'Kalem ekle',
    compare: 'Sürümleri karşılaştır',
    addAlternative: 'Alternatif ekle',
    reject: 'Reddet',
  },
  filters: {
    search: 'Numara, reçete veya çıktı ürünü ara',
    status: 'Yaşam döngüsü durumu',
    allStatuses: 'Tüm durumlar',
    validOn: 'Geçerlilik tarihi',
    componentSearch: 'Ürün, reçete, kalem veya yorum ara',
  },
  columns: {
    number: 'Numara',
    name: 'Ad',
    output: 'Çıktı ürünü',
    version: 'Sürüm',
    status: 'Durum',
    reference: 'Referans miktar',
    components: 'Kalemler',
    cost: 'Malzeme maliyeti',
    validity: 'Geçerlilik',
    updated: 'Son değişiklik',
  },
  statuses: {
    DRAFT: 'Taslak',
    IN_REVIEW: 'İncelemede',
    APPROVED: 'Onaylı',
    BLOCKED: 'Bloke',
    ARCHIVED: 'Arşivli',
  },
  componentTypes: {
    MATERIAL: 'Malzeme',
    SUB_RECIPE: 'Alt reçete',
    PACKAGING: 'Ambalaj',
    BY_PRODUCT: 'Yan ürün',
  },
  substitutionStatuses: {
    PROPOSED: 'Önerildi',
    APPROVED: 'Onaylı',
    REJECTED: 'Reddedildi',
    ARCHIVED: 'Arşivli',
  },
  editor: {
    newTitle: 'Reçete / BOM oluştur',
    newDescription: 'Sabit kimliği ve ilk düzenlenebilir sürümü oluşturun.',
    versionDescription: 'Kontrollü sürüm v{{version}}',
    reorder: 'Kalemi yeniden sırala',
  },
  fields: {
    number: 'Reçete / BOM numarası',
    outputProduct: 'Çıktı ürünü',
    name: 'Ad',
    baseQuantity: 'Referans miktar',
    baseUnit: 'Temel birim',
    validFrom: 'Geçerlilik başlangıcı',
    validTo: 'Geçerlilik sonu',
    currency: 'Maliyet para birimi',
    comments: 'İç yorumlar',
    localizedName: 'Yerelleştirilmiş ad',
    description: 'Açıklama',
    position: 'Kalem',
    type: 'Kalem türü',
    component: 'Bileşen',
    quantity: 'Miktar',
    unit: 'Birim',
    percentage: 'Pay %',
    loss: 'Kayıp %',
    declarationRelevant: 'Beyanla ilgili',
    alternatives: 'Alternatifler',
    comment: 'Yorum',
    selectSubRecipe: 'Onaylı alt reçete seç',
    selectProduct: 'Ürün seç',
    alternativeProduct: 'Alternatif ürün',
    alternativeRecipe: 'Alternatif alt reçete',
    factor: 'İkame faktörü',
    rationale: 'Teknik gerekçe',
    reason: 'Gerekçe ve karar notu',
  },
  sections: {
    header: 'Reçete başlığı',
    translations: 'Diller',
    components: 'Bileşenler ve alt reçeteler',
    snapshotDocuments: 'Sürüm belge anlık görüntüsü',
    history: 'Sürüm geçmişi',
    whereUsed: 'Üst reçeteler ve etkilenen ürünler',
    affectedProducts: 'Tüm BOM seviyelerindeki etkilenen ürünler',
    productUsage: 'Seçilen bileşenin kullanımı',
    documents: 'Reçete DMS dosyası',
  },
  summary: {
    quantities: 'Birime göre kalem toplamları',
    percentage: 'Girilen pay toplamı',
    cost: 'Hesaplanan malzeme maliyeti',
  },
  warnings: {
    UNIT_NOT_SUMMABLE: '{{position}} numaralı kalem {{unit}} temel birimine dönüştürülemiyor.',
    COMPONENT_ARCHIVED: '{{position}} numaralı kalemdeki ürün arşivlenmiş.',
    SUB_RECIPE_NOT_APPROVED: '{{position}} numaralı kalemdeki alt reçete onaylı değil.',
    PERCENTAGE_TOTAL_NOT_100: 'Girilen oranların toplamı %100 yerine %{{percentage}}.',
    INPUT_OUTPUT_DEVIATION:
      'Dönüştürülebilen girdiler ({{input}} {{unit}}), referans çıktıdan ({{output}} {{unit}}) farklı.',
  },
  states: {
    invalidDecimal: 'Geçersiz ondalık',
    noDocuments: 'Korumalı reçete belgesi yok.',
    notUsed: 'Kullanım bulunamadı.',
  },
  messages: {
    saved: 'Reçete sürümü kaydedildi.',
    invalid: 'Geçersiz reçete verilerini düzeltin.',
    submitted: 'Reçete bağımsız incelemeye gönderildi.',
    workflowUpdated: 'Reçete iş akışı güncellendi.',
  },
  tabs: {
    editor: 'Düzenleyici',
    history: 'Sürümler ve karşılaştırma',
    impact: 'Kullanım / etki',
    processRouting: 'Proses rotası',
    documents: 'DMS belgeleri',
  },
  alternatives: {
    title: 'Alternatif bileşenler ve onaylı ikameler',
    empty: 'Bu kalem için alternatif tanımlanmadı.',
  },
  actionDialog: {
    REVIEW: {
      title: 'Teknik incelemeyi tamamla',
      description: 'Bağımsız incelemeyi izlenebilir bir notla doğrulayın.',
    },
    APPROVE: {
      title: 'Reçete sürümünü onayla',
      description: 'Onay bu sürümü dondurur ve dört göz ilkesini uygular.',
    },
    COPY: {
      title: 'Yeni sürüme kopyala',
      description: 'Düzenlenebilir taslak oluşturulur ve ikame kararları yeniden incelenir.',
    },
    BLOCK: {
      title: 'Reçete sürümünü bloke et',
      description: 'Sürüm değişmez kalır ancak artık kullanılamaz.',
    },
    ARCHIVE: {
      title: 'Reçete sürümünü arşivle',
      description: 'Sürüm izlenebilir kalır ve aktif kullanımdan çıkar.',
    },
    SUB_APPROVE: {
      title: 'İkameyi onayla',
      description: 'Teknik eşdeğerliği ve kanıtını bağımsız olarak doğrulayın.',
    },
    SUB_REJECT: {
      title: 'İkameyi reddet',
      description: 'Alternatifin neden kullanılamayacağını belgeleyin.',
    },
  },
  compare: {
    title: 'Reçete sürümlerini karşılaştır',
    description: 'Farklar değişmez sürüm anlık görüntülerinden türetilir.',
    headerChanges: 'Başlık değişiklikleri',
    none: 'Başlık değişikliği yok.',
    added: 'Eklenen kalemler',
    removed: 'Kaldırılan kalemler',
    changed: 'Değişen kalemler',
  },
  compareFields: {
    name: 'Ad',
    baseQuantity: 'Referans miktar',
    baseUnitCode: 'Temel birim',
    validFrom: 'Geçerlilik başlangıcı',
    validTo: 'Geçerlilik sonu',
    comments: 'Yorumlar',
    dmsAttachmentIds: 'DMS belge anlık görüntüsü',
    costCurrency: 'Maliyet para birimi',
    internalMaterialCost: 'Malzeme maliyeti',
    translations: 'Çeviriler',
  },
} as const;
